import React from "react";

import Content from "../components/OrderPriceCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function orderPrice({ width, onResize }: Column.Options) {
	return base(ColumnId.OrderPrice, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default orderPrice;
